import { Autocomplete, Box, TextField, useTheme } from "@mui/material";
import React from "react";
import LocationOutline from "../../../../../../../media/images/icons/location-icon";

interface Props {
  options: {
    id: number;
    label: string;
  }[];
  placHolder: string;
  icon?: React.ReactNode;
}

export default function CustomAutoComple({ options, placHolder, icon }: Props) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        flex: "1",
        borderRadius: "8px",
        border: "1px solid gray",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        paddingY: "4px",
        paddingX: "4px",
      }}
    >
      {icon}
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        options={options}
        sx={{
          padding: "0px !important",

          flex: "1",
          "& .MuiInputBase-root": {
            paddingRight: "0px !important",
            padding: "0px !important",
          },
          "& .MuiAutocomplete-endAdornment": {
            position: "static",
          },
          "& .MuiInputBase-input": {
            border: "none !important",
            outline: "none !important",
            padding: "0px !important",
            paddingLeft: "0px !important",
            paddingRight: "0px !important",
          },

          "& .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
            outline: "none !important",
            paddingLeft: "0px !important",
            paddingRight: "0px !important",
          },
          border: "none",
        }}
        renderInput={(params) => {
          const newParams = {
            ...params,
            InputProps: {
              ...params.InputProps,
              placeholder: placHolder,
            },
          };

          return <TextField {...newParams} label="" />;
        }}
      />
    </Box>
  );
}
